
export const SETTINGS = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8081'
}

export const AUTH_CONFIG = {
    domain: process.env.REACT_APP_AUTH0_DOMAIN || 'seetrai.auth0.com',
    clientId: process.env.REACT_APP_AUTH0_CLIENTID || '6OSt2dku6RERVzrUQdJtfwhdCQrpR2VW',
    callbackUrl: process.env.REACT_APP_AUTH0_CALLBACKURL || 'http://localhost:3000/callback'
  }